import React from 'react';
import { injectIntl } from 'react-intl';
import { Thumbnail, DropdownButton, MenuItem } from 'react-bootstrap';

@injectIntl
export default class StartupInfo extends React.Component {
  render() {
    const { startup, imageUrl, intl } = this.props;

    if (startup == undefined) {
      return (
        <div
          style={{
            textAlign: 'center',
            marginBottom: 20
          }}
          id="user-info"
          className="sidebar-item"
        />
      );
    }
  
    return (
      <div
        
        id="user-info"
        className="sidebar-item"
      >
        <Thumbnail
          title={intl.formatMessage({ id: 'edit_startup' })}
          src={imageUrl}
          href={`/gstartup/${startup.id}/edit`}
          style={{ width: '40%', height: '100%' }}
          className="img-circle"
        />
        <h2>{startup.name}</h2>
      </div>
    );
  }
}
